var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('timeline',{ref:"timeline",attrs:{"db":"tasks","sortimenter":"users","property":"manager","methods":{ getColor: _vm.getColor },"defaultduration":432000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }